import { MButton, MoreButton } from '@Components/Base';
import { Flex } from 'antd';
import { ReactComponent as ChevroneIcon } from '@Icons/additional/chevron-right.svg';
import { ReactComponent as CloseIcon } from '@Icons/additional/close-cross.svg';

import styles from './approve-footer.module.css';

interface ApproveFooterProps {
  onApprove: () => void;
  onCancel: () => void;
  onPricingBreakdown: () => void;
  totalAmount: number;
}

const ApproveFooter: React.FC<ApproveFooterProps> = ({
  onApprove,
  onPricingBreakdown,
  onCancel,
  totalAmount,
}) => {
  const actions = [
    {
      key: '0',
      label: (
        <Flex className="trojan-more-action-item" onClick={onCancel}>
          <CloseIcon />
          <span>Cancel</span>
        </Flex>
      ),
    },
  ];

  return (
    <Flex vertical gap={8} style={{ height: '100%' }} justify="space-around">
      <Flex
        className={styles.footerHeader}
        justify="space-between"
        onClick={onPricingBreakdown}
      >
        <Flex vertical justify="space-around">
          <div className={styles.caption}>Final Ammount</div>
          <div>
            {totalAmount} AED /{' '}
            <span className={styles.priceBreakdown}>Price Breakdown</span>
          </div>
        </Flex>
        <div className={styles.chevrone}>
          <ChevroneIcon />
        </div>
      </Flex>
      <Flex gap={8}>
        <MButton type="primary" style={{ width: '100%' }} onClick={onApprove}>
          <Flex gap={8} justify="space-between">
            <span>Approve</span>
          </Flex>
        </MButton>
        <MoreButton title="Choose Actions" actionItems={actions} />
      </Flex>
    </Flex>
  );
};

export default ApproveFooter;
